/** Validates that url does not contain null in pathname.
 *
 * @param url The url to validate.
 * @returns {boolean} true or false if pathname does not contain null
 */
const isValidUrlPath = (url) => {
	const parser = document.createElement('a');

	parser.href = url;

	return !!parser.pathname.match(/^((?!null).)*$/);
};

export default isValidUrlPath;
